import { CartPromotionModel } from "./cart-promotion/cart-promotion.models";
import { PromotionCodeModel } from "./promotion/promotion.models";
import { ShoppingCartGiftItemModel } from "./shopping-cart/shopping-cart.models";

export interface FreeConditionModel{
    quantity: number;
    maxPrice: number;
}

export interface PromotionProductModel{
    id: number;
    name: string;
    image: string;
    categoryName: string;
    price: number;
}
export const checkFreeCondition = (promotion: CartPromotionModel |  PromotionCodeModel,
    shoppingCartGiftItems: ShoppingCartGiftItemModel[],
    price: number, quantity: number) => {
    let cartPromotionTemp = { ...promotion };
    cartPromotionTemp.freeConditions.sort((a, b) => a.maxPrice - b.maxPrice);
    let slot = 0;
    for (let i = 0; i < cartPromotionTemp.freeConditions.length; i++) {
      const quantityInShoppingCart = shoppingCartGiftItems
        .filter(
          (x) =>
            x.maxPrice >
              (i === 0
                ? 0
                : cartPromotionTemp.freeConditions[i - 1].maxPrice) &&
            x.maxPrice <= cartPromotionTemp.freeConditions[i].maxPrice
        )
        .map((x) => x.quantity)
        .reduce((a, b) => a + b, 0);
        const availableSlot = cartPromotionTemp.freeConditions[i].quantity - quantityInShoppingCart;
        //Nếu price > thì bắt buộc availableSlot <0 em chạy thử xem
        if((availableSlot <0 && price > cartPromotionTemp.freeConditions[i].maxPrice) || price <= cartPromotionTemp.freeConditions[i].maxPrice){
            slot += availableSlot;
        }
    }
    return slot >= quantity;
  };